import {
  ActiveProduct,
  ActiveVariant,
  Product,
  Variant,
} from "../../types/types";

export function ensureIsActive(product: Product): ActiveProduct | null {
  const isActive =
    product.__typename === "SimpleProduct" ||
    product.__typename === "CompositeBundle" ||
    product.__typename === "StaticBundle";

  if (isActive) {
    return product;
  } else {
    return null;
  }
}

export function ensureIsActiveVariant(variant: Variant): ActiveVariant | null {
  const isActive =
    variant.__typename === "StockVariant" ||
    variant.__typename === "StaticBundleVariant" ||
    variant.__typename === "CompositeBundleVariant";

  if (isActive) {
    return variant;
  } else {
    return null;
  }
}
